import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchPublicTransportMetroStation } from "../../../api/transportPublicApi";
import {
  TransportPublicAttribution,
  TransportPublicCtas,
  TransportPublicHero,
} from "../../../components/midpoint/transport/public/TransportPublicSections";
import { useTransportPublicSeo, trackTransportPublicEvent } from "../../../hooks/useTransportPublicSeo";
import TransportPublicLayout from "./TransportPublicLayout";

const TransportMetroStationPage = () => {
  const { stationSlug } = useParams();
  const [payload, setPayload] = useState(null);
  const [error, setError] = useState(null);

  useTransportPublicSeo(payload?.seo);

  useEffect(() => {
    let cancelled = false;
    fetchPublicTransportMetroStation(stationSlug)
      .then((body) => {
        if (!cancelled) {
          setPayload(body);
          trackTransportPublicEvent("transport_public_page_view", {
            pageType: "metro_station",
            slug: stationSlug,
          });
        }
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Unable to load page.");
      });
    return () => {
      cancelled = true;
    };
  }, [stationSlug]);

  if (error || !payload) {
    return (
      <TransportPublicLayout title="Metro access">
        <p>{error || "Loading station access…"}</p>
      </TransportPublicLayout>
    );
  }

  return (
    <TransportPublicLayout title="Metro station access">
      <TransportPublicHero hero={payload.hero} freshness={payload.freshness} />
      <section className="transport-public-section">
        <h2>Station context</h2>
        <p>
          {payload.station.name} · {payload.station.neighborhood || payload.station.municipality || "Medellín"}
        </p>
        {payload.ridership?.averagePassengers != null ? (
          <p className="transport-public-disclaimer">
            Historical ridership pressure: ~{Math.round(payload.ridership.averagePassengers)} passengers (90-day
            average). {payload.ridership.disclaimer}
          </p>
        ) : (
          <p className="transport-public-disclaimer">{payload.ridership?.disclaimer}</p>
        )}
      </section>
      <TransportPublicAttribution attribution={payload.attribution} />
      <TransportPublicCtas ctas={payload.ctas} />
    </TransportPublicLayout>
  );
};

export default TransportMetroStationPage;
